import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => ({
  container: {
    display: "flex !important",
    flex: 1,
    justifyContent: "space-between",
  }
}));
